import * as types from './types'
import http from '@/Plugins/api'

export default {
  setPager({ commit }, data) {
    commit(types.SET_PAGER, data)
  },
  setChecked({ commit }, data) {
    commit(types.SET_CHECKED, data)
  },
  resetProgram({ commit }, data) {
    commit(types.RESET_PROGRAM, data)
  },
  setProgramData({ commit }, data) {
    commit(types.SET_PROGRAM_DATA, data)
  },
  async getPrograms({ commit }, data) {
    const r = await http.get(`v2/programs`, {
      params: data,
    })
    commit(types.SET_PROGRAMS, r.data.data)
    return r.data.data
  },
  async getProgram({ commit }, id) {
    const r = await http.get(`v2/programs/edit/${id}`)
    commit(types.SET_PROGRAM, r.data.data)
    return r.data.data
  },
  async saveProgram({ commit }, data) {
    let r = null
    if (data.id === null) {
      r = await http.post('v2/programs', data).catch((error) => {
        return { data: { data: null, error: error.response.data.message } }
      })
    } else {
      r = await http.post('v2/programs/update', data).catch((error) => {
        return { data: { data: null, error: error.response.data.message } }
      })
    }
    return r.data
  },
  async removeProgram({ commit }, id) {
    const r = await http.delete(`v2/programs/${id}`)
    return r.data.data
  },
}
